module.exports = __webpack_public_path__ + "img/w4_01.28248499.jpg";